import React from 'react';
import { Link } from 'react-router-dom';

function Article({ article }) {
  const dateObj = (dateString) => {
    const date = new Date(dateString);
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
    };
  };

  const date = dateObj(article.update_date);

  return (
    <Link to="#!" className="group block h-full">
      <div className="premium-card h-full bg-white">
        <div className="relative h-64 overflow-hidden bg-slate-100">
          <img className="h-full w-full object-cover transition duration-500 group-hover:scale-105" src={article.main_image} alt={article.title} loading="lazy" />
          <div className="absolute left-4 top-4 rounded-2xl bg-white/95 p-3 text-center shadow-lg">
            <p className="text-2xl font-black text-ink">{date.day}</p>
            <p className="text-xs font-black uppercase tracking-wide text-muted">{date.month}</p>
            <p className="text-xs font-bold text-muted">{date.year}</p>
          </div>
        </div>
        <div className="p-6">
          <p className="text-sm font-bold uppercase tracking-wide text-gotrip-700">{article?.group_title?.group_title || 'Travel insights'}</p>
          <h3 className="mt-3 text-2xl font-black tracking-tight text-ink group-hover:text-gotrip-700">{article.title}</h3>
          <p className="mt-4 leading-7 text-muted">{article.description || 'Read the latest travel stories, booking tips, and destination guides from GoTrip.'}</p>
          <div className="mt-6 inline-flex items-center gap-2 text-sm font-black text-gotrip-700">
            Read article
            <svg className="h-4 w-4 transition group-hover:translate-x-1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M13 5l7 7-7 7" />
            </svg>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default Article;
